import { createSlice } from '@reduxjs/toolkit';

export const forgotPassword = createSlice({
    name: 'forgotPassword',

    initialState: {
        forgotPasswordModal: false
    },

    reducers: {
        setForgotPasswordModal: (state, action) => {
            state.forgotPasswordModal = action.payload;
        }
    }
});

export const { setForgotPasswordModal } = forgotPassword.actions;

export default forgotPassword.reducer;
